module.exports = __webpack_public_path__ + "uruguay.svg?9860a4374a619f6d6b9bf34b3ecb94fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/uruguay.svg
// module id = 334
// module chunks = 10